/*
* 业务规则配置中的人员角色权限
* */
import store from '@/store'
export default {
    inserted(dom, binding) {
        const permissions = store.getters.getPermissions
        if(permissions.length == 0) {
            dom.style.visibility = 'hidden'
        } else {
            const value = binding.value
            if (value && value instanceof Array && value.length > 0) {
                const hasPermis = permissions.some(permission => {
                    return value.includes(permission)
                })
                if (!hasPermis) {
                    dom.style.visibility = 'hidden'
                }
            } else {

            }
        }
    }
}
